import * as React from "react";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { Paper, PaperProps, Typography } from "@material-ui/core";

// Icons
import AlarmOnRoundedIcon from "@material-ui/icons/AlarmOnRounded";

// NPM
import clsx from "clsx";
import Utility from "../../domain/classes/Utility";

export const styles = (theme: Theme) =>
	createStyles({
		root: {
			padding: theme.spacing(1),
		},
	});

export interface CheckinReminderProps extends PaperProps {}

const CheckinReminder = React.forwardRef<
	HTMLDivElement,
	CheckinReminderProps & WithStyles<typeof styles>
>(({ classes, className, ...paperProps }, ref) => {
	return (
		<Paper
			component="div"
			square
			variant="outlined"
			{...paperProps}
			className={clsx(classes.root, className)}
		>
			<AlarmOnRoundedIcon color="primary" />
			<Typography variant="body1">
				<strong>A check-in link</strong>&nbsp; will be sent to your
				mobile number 24 hours prior to your appointment.
			</Typography>
		</Paper>
	);
});

export default withStyles(styles, {
	classNamePrefix: Utility.generateClassName("CheckinReminder"),
})(CheckinReminder);
